import { RatesPage } from 'pageModules/RatesPage';

export default RatesPage;
